import React from 'react';
import './join-us.sass';
import LandingImage from '../../assets/Landing_page.png';
import {Button, ButtonSize, ButtonType} from '../../../../../components/interface/button/button';
import { useScrollElement } from '../../../../../components/hooks/use-scroll-element';

export const JoinUs = ({scrollRef}) => {

    const {onScroll} = useScrollElement(scrollRef);

    return (
        <div className='vv-landing-page-vendor-join-us-container'>
            <div className='vv-landing-page-vendor-join-us'>
                <div className='vv-landing-page-vendor-join-us__info'>
                    <h2>Przyciągnij odpowiednich gości do swojego lokalu!</h2>
                    <p>Chcesz przyciągnąć uczestników koncertu hip-hopowego czy gości filharmonii? Ty decydujesz kiedy i komu dajesz zniżki!</p>
                    <Button size={ButtonSize.VENDOR} buttonType={ButtonType.BLACK} text='DOŁĄCZ' onClick={() => onScroll()}/>
                </div>
                <img className='vv-landing-page-vendor-join-us__image' src={LandingImage}/>
            </div>
        </div>
    );
};
